<template>
  <div class="">

    <b-col class="text-left mb-2">
      <m-a :href="{name:'Brands'}" class="text-decoration-none">
        <span>
          <b-icon-arrow-left class="custom-icon-font-size "/>
        </span>

        <span class="see-more-link">
            مشاهده همه
          </span>
      </m-a>
    </b-col>


    <swiper
        :options="swiperOptions"
        v-if="$store.getters['Brand/getBrands'].length > 0"

    >
      <swiper-slide
          v-for="brand in $store.getters['Brand/getBrands']"
          :key="brand.id"
      >
        <div class="card borderless">
          <img class="card-img-top" :alt="brand.name" :src="brand.image"/>
          <div class="card-body">
            <router-link
                class="brand-link text-decoration-none"
                :to="{
              name: 'Products',
              query: { page: 1, brand: brand.id },
            }"
            >
              <span>{{ brand.name }}</span>
            </router-link>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
  </div>
</template>

<script>
import {Swiper, SwiperSlide} from "vue-awesome-swiper";

export default {
  name: "Slider-3",
  components: {Swiper, SwiperSlide},
  data() {
    return {
      swiperOptions: {
        slidesPerView: 5,
        spaceBetween: 70,
        loop: true,
        autoplay: {
          delay: 7000,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          300: {
            slidesPerView: 2,
          },
          480: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 4,
          },
          980: {
            slidesPerView: 3,
          },
          1200: {
            slidesPerView: 5,

          },
        },
      },
    };
  },
  mounted() {
    this.$store.dispatch("Brand/getBrands");
  },
};
</script>

<style scoped>
.borderless {
  border: none;
}

.card-body {
  padding: 0px;
  text-align: center;
}

.brand-link {
  font-weight: bold;
  font-size: 12px;
  color: black;
}

.card {
  max-width: 150px;
  min-width: 150px;
}

.card-img-top {
  object-fit: contain;
  height: 100px;
  width: 100%;
}
</style>